import WhatsappContactLink from '../link/whatsapp-contact-link';

interface IContactButtonProps {
	color?: 'black' | 'white';
}

const ContactButton = (props: IContactButtonProps) => {
	const { color = 'white' } = props;

	let className = 'bg-base-100 border-0 border-t-4 border-primary text-primary-content roboto text-lg px-8 py-2';

	if (color === 'black') {
		className = 'bg-black border-0 border-t-4 border-primary text-secondary-content roboto text-lg px-8 py-2';
	}

	return (
		<WhatsappContactLink className={className}>
			Entre em contato
		</WhatsappContactLink>
	);
};

export default ContactButton;
